/* eslint-disable*/
import VueStoreService from './VueStoreService';
const StoresService = {
    async getStores(url,store){
        var resp = await VueStoreService.get("establishment"+url, store)
        return resp;
    },
    async saveStore(data,store){
        var resp = await VueStoreService.post("establishment",data,store)
        return resp;
    },
    async getStore(store_id,store){
        var resp = await VueStoreService.get( "establishment/"+store_id,store)
        return resp;
    },
    async updateStore(store_id,data,store){
        var resp = await VueStoreService.patch("establishment/"+store_id,data,store)
        return resp;
    },

    async deleteStore(store_id,store){
        var resp = await VueStoreService.delete("establishment/"+store_id,store)
        return resp;
    },
}

export default StoresService;